interface ValetRequestSuccessProps {
  requestId: string;
  onDone: () => void;
}

export default function ValetRequestSuccess({ requestId, onDone }: ValetRequestSuccessProps) {
  return (
    <div className="valet-request-success">
      <div className="success-icon-wrapper">
        <svg className="success-icon" width={64} height={64} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5}>
          <circle cx={12} cy={12} r={10} />
          <path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      <h1 className="success-title">Request Sent!</h1>

      <p className="success-message">
        Your valet request has been sent to the team. You'll receive updates on the status of your request.
      </p>

      <div className="request-id-display">
        <span className="request-id-label">Request ID:</span>
        <span className="request-id-value">{requestId}</span>
      </div>

      <div className="info-box">
        <div className="info-item">
          <span className="info-label">What happens next</span>
          <p className="info-text">
            The valet team will be notified immediately. Once they accept your request, you'll be able to track its progress.
          </p>
        </div>
      </div>

      <button className="btn-done" onClick={onDone}>
        Done
      </button>

      <style>{`
        .valet-request-success {
          text-align: center;
          padding: 40px 24px;
          max-width: 480px;
          margin: 0 auto;
        }

        .success-icon-wrapper {
          margin-bottom: 24px;
        }

        .success-icon {
          color: var(--emerald-500);
        }

        .success-title {
          font-size: 28px;
          font-weight: 700;
          color: var(--stone-900);
          margin: 0 0 16px 0;
        }

        .success-message {
          font-size: 16px;
          color: var(--stone-600);
          line-height: 1.6;
          margin: 0 0 24px 0;
        }

        .request-id-display {
          background: var(--stone-100);
          padding: 12px 20px;
          border-radius: 8px;
          margin-bottom: 24px;
          display: inline-block;
        }

        .request-id-label {
          display: block;
          font-size: 11px;
          font-weight: 600;
          color: var(--stone-500);
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 4px;
        }

        .request-id-value {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: var(--stone-900);
          font-family: "SF Mono", Monaco, monospace;
        }

        .info-box {
          background: var(--blue-50);
          border: 1px solid var(--blue-200);
          border-radius: 12px;
          padding: 20px;
          margin-bottom: 32px;
          text-align: left;
        }

        .info-label {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: var(--blue-700);
          margin-bottom: 8px;
        }

        .info-text {
          font-size: 14px;
          color: var(--blue-600);
          line-height: 1.6;
          margin: 0;
        }

        .btn-done {
          width: 100%;
          padding: 16px 24px;
          background: var(--stone-900);
          color: var(--white);
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s;
        }

        .btn-done:hover {
          background: var(--stone-800);
        }
      `}</style>
    </div>
  );
}
